import { useCallback, useEffect, useState } from "react";


import EmploymentType from "../pages/EmploymentType";
import Deduction from "../pages/PayrollDeduction";
import Income from "../pages/PayrollIncome";
import Welfare from "../pages/PayrollWelfare";

import {
  PAYROLL_PAGE
} from "../schemas/payrollSchema";
import { useLocation } from "react-router-dom";
import FundFormPage from "features/fund/pages/FundFormPage";
import FundList from "features/fund/pages/FundList";

function useAttendance() {
  const [selectedMenu, setMenu] = useState(PAYROLL_PAGE.EMPLOYMENT_TYPE_SETUP);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.selectedTab) {
      setMenu(location.state.selectedTab);
    }
  }, [location.state]);

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case PAYROLL_PAGE.EMPLOYMENT_TYPE_SETUP:
        return <EmploymentType />;
      case PAYROLL_PAGE.INCOME:
        return <Income />;
      case PAYROLL_PAGE.DEDUCTION:
        return <Deduction />;
      case PAYROLL_PAGE.WELFARE:
        return <Welfare />;
      case PAYROLL_PAGE.FUND:
        return <FundList />;
      default:
        return <div />;
    }
  }, [selectedMenu]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  // useEffect(() => {
  //   const key = storage.sessionStorage.getItem("config.menu");
  //   if (PAYROLL_PAGE_LIST.includes(key)) {
  //     setSelectedMenu(key);
  //   } else {
  //     setSelectedMenu(PAYROLL_PAGE.EMPLOYMENT_TYPE_SETUP);
  //   }
  // }, []);

  return {
    getPage,
    handleMenuChange,
    selectedMenu
  };
}

export default useAttendance;
